module.exports = __webpack_public_path__ + "img/0Q3B5795_FoamcoreMatted.151f30b2.jpg";